import { useEffect, useMemo } from 'react';
import AuthSection from './AuthSection';
import { getThemeTokens } from './sharedTheme';

export default function PublicNewsletterPage() {
  const { COLORS, inputStyle } = useMemo(() => getThemeTokens(localStorage.getItem('themeMode') || 'dark'), []);
  useEffect(() => {
    const previous = document.title;
    document.title = 'Newsletter | Einfach-Trading.de';
    return () => { document.title = previous; };
  }, []);
  return <AuthSection COLORS={COLORS} inputStyle={inputStyle} authMode="newsletter" footer={
    <footer style={{ padding: '18px 24px 26px', textAlign: 'center', fontSize: 13, lineHeight: 1.7 }}>
      <a href="https://www.einfach-trading.de/rechtliches.html" target="_blank" rel="noreferrer" style={{ color: COLORS.muted }}>Impressum und Datenschutz</a>
    </footer>
  } />;
}
